import styled, { createGlobalStyle } from 'styled-components';
import Link from '../../components/Link';
import ButtonLink from '../../components/Link/StyledLink';
import Search from '../../components/Search';
import Button from '../../components/Button';

export const Root = styled.div`
	padding-top: 50px;
	color: ${({ theme }) => theme.primaryBlackColor};
	${({ theme }) => theme.typography.textM};
`;

export const SearchPanel = styled(Search)`
	input {
		padding-left: 0;
		border-top: none;
		border-right: none;
		border-left: none;
	}
`;

export const Container = styled.div`
	max-width: 1400px;
	margin: 0 auto;

	@media (max-width: 1430px) {
		max-width: 100%;
		width: 100%;
		box-sizing: border-box;
		margin: 0 auto;
		padding-left: 15px;
		padding-right: 15px;
	}
`;

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 40px;
`;

export const Title = styled.h1`
	margin: 0;
	color: #000;
	${({ theme }) => theme.typography.headlineXXL};
`;

export const Subtitle = styled.h2`
	margin: 0 0 36px;
	${({ theme }) => theme.typography.headlineXL};
`;

export const SubtitleLink = styled(Link)`
	color: ${({ theme }) => theme.primaryBlackColor};
	text-decoration: none;

	&:hover,
	&:active {
		color: ${({ theme }) => theme.primaryColor};
	}
`;

export const SearchWrapper = styled.div`
	width: 50%;

	@media (max-width: 580px) {
		width: 100%;
	}
`;

const getSectionColor = (type, theme) => () => {
	if (type === 'light') {
		return theme.lightGrayColor;
	}
	if (type === 'dark') {
		return theme.primaryBlackColor;
	}
	return '#fff';
};

export const ArticleTitle = styled.h3`
	margin: 8px 0;
	color: ${({ theme }) => theme.primaryBlackColor};
	transition: color 0.2s ease;
	cursor: pointer;
	${({ theme }) => theme.typography.textBoldL};

	& > a {
		color: ${({ theme }) => theme.primaryBlackColor};
		text-decoration: none;

		&:hover,
		&:active {
			color: ${({ theme }) => theme.primaryColor};
		}
	}
`;

export const Section = styled.section`
	padding: 40px 0 70px 0;
	background-color: ${({ scheme, theme }) => getSectionColor(scheme, theme)};

	${SubtitleLink} {
		color: ${props => props.scheme === 'dark' && '#fff'};
		border-bottom-color: ${props => props.scheme === 'dark' && '#fff'};

		&:hover,
		&:active {
			color: ${({ scheme, theme }) => scheme === 'dark' && theme.toxicLimeColor};
			border-bottom-color: ${({ scheme, theme }) => scheme === 'dark' && theme.toxicLimeColor};
		}
	}

	${ArticleTitle} {
		color: ${props => props.scheme === 'dark' && '#fff'};

		&:hover,
		&:active {
			color: ${({ scheme, theme }) => scheme === 'dark' && theme.toxicLimeColor};
		}
	}

	${Button} {
		color: ${props => props.scheme === 'dark' && '#fff'};
		border-color: ${props => props.scheme === 'dark' && '#fff'};

		&:hover,
		&:active {
			border-color: ${({ scheme, theme }) => scheme === 'dark' && theme.toxicLimeColor};
		}
	}
`;

export const ArticleImg = styled.div`
	display: block;
	width: 100%;
	height: 0;
	padding-bottom: 100%;
	background: ${({ theme, bg }) => `${theme.darkGrayColor} url(${bg}) no-repeat center center`};
	background-size: cover;
	margin-bottom: 15px;

	@media (max-width: 768px) {
		padding-bottom: 47.5%;
	}
`;

export const ArticleRubric = styled(Link)`
	color: ${({ theme }) => theme.darkGrayColor};
	text-decoration: none;
	${({ theme }) => theme.typography.textAccentXS};

	&:hover,
	&:active {
		text-decoration: underline;
	}
`;

// TODO Make it link
export const KnowledgeRubric = styled.span`
	color: ${({ theme }) => theme.darkGrayColor};
	text-decoration: none;
	${({ theme }) => theme.typography.textAccentXS};
`;

export const ArticleText = styled.div`
	p {
		margin: 8px 0 16px;
	}
`;

export const ArticleDate = styled.p`
	color: ${({ theme }) => theme.darkGrayColor};
	margin: 20px 0;
`;

export const ArticleItem = styled.div`
	display: flex;
	flex-direction: column;
	width: 25%;
	padding: 15px;
	box-sizing: border-box;

	@media (max-width: 768px) {
		width: 50%;
	}

	@media (max-width: 560px) {
		width: 100%;
	}
`;

export const ArticleColored = styled.div`
	background-color: ${props => props.bgColor};
	padding: 20px 22px;
	box-sizing: border-box;
`;

export const ExpertiseArticles = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-wrap: wrap;
	margin: -15px;
`;

export const ExpertiseItem = styled(ArticleItem)`
	&:nth-child(1),
	&:nth-child(5) {
		width: 50%;

		@media (max-width: 560px) {
			width: 100%;
		}

		${ArticleImg} {
			padding-bottom: 47.5%;
		}
	}
`;

export const ExpertiseContent = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
`;

export const PlayIcon = styled.svg`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 50px;
	height: 50px;
	fill: #fff;
	transition: fill 0.2s ease;
	z-index: 11;
`;

export const VideoPreview = styled.div`
	position: relative;
	width: 100%;
	height: 0;
	padding-bottom: 56.25%;
	margin-bottom: 12px;

	&:hover,
	&:active {
		${PlayIcon} {
			fill: ${({ theme }) => theme.toxicLimeColor};
		}
	}
`;

export const VideoPoster = styled.span`
	position: absolute;
	display: block;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: #898989;
	background-position: center center;
	background-size: cover;
	background-repeat: no-repeat;
	opacity: 0.7;
	transition: opacity 0.2s ease;
	z-index: 10;
`;

export const VideoWrapper = styled(Link)`
	display: flex;
	flex-direction: column;
	padding: 15px;
	box-sizing: border-box;
	text-decoration: none;
	cursor: pointer;

	&:hover,
	&:active {
		${VideoPoster} {
			opacity: 1;
		}

		${PlayIcon} {
			fill: ${({ theme }) => theme.toxicLimeColor};
		}

		${ArticleTitle} {
			color: ${({ theme }) => theme.toxicLimeColor};
		}
	}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	padding: 50px 0 0;
`;

export const StyledButtonLink = styled(ButtonLink)`
	font-weight: 300;
	border-radius: 24px;
`;

export const VideoButtonLink = styled(StyledButtonLink)`
	border-color: #fff;
	color: #fff;

	&:hover {
		border-color: ${props => props.theme.primaryColor};
	}
`;

export const VideoSlider = createGlobalStyle`
	.slick-slider {
		width: 100%;
	}

	.slick-slide {
		opacity: 0.5;

		&.slick-active {
			opacity: 1;
		}
	}

	.slick-arrow {
		position: absolute;
		top: 0;
		z-index: 1;
		height: 100%;
		width: 60px;
		padding: 0;
		background-color: transparent;
		border: none;
		box-shadow: none;
		cursor: pointer;
		transition: opacity 0.2s ease;

		&::before {
			content: '';
			position: absolute;
			top: 35%;
			display: block;
			width: 30px;
			height: 30px;
			border-top: 2px solid #fff;
			border-right: 2px solid #fff;
			opacity: 0.5;
			transition: opacity 0.2s ease;
		}
	}

	.slick-prev {
		left: 0;

		&::before {
			left: 40%;
			transform:  rotate(-135deg);
		}

		&:hover {
			&::before {
				opacity: 1;
			}
		}
	}

	.slick-next {
		right: 0;

		&::before {
			right: 40%;
			transform: rotate(45deg);
		}

		&:hover {
			&::before {
				opacity: 1;
			}
		}
	}
`;
